<!-- 客户价格等级 -->
<template>
    <div>
        <div class="form-main">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="80px" class="formData">
                <el-form-item label="级别名称" prop="LevelName">
                    <el-input v-model="formData.LevelName"></el-input>
                </el-form-item>
                <el-form-item label="价格类型" prop="PriceType">
                    <el-select v-model="formData.PriceType" clearable style="width: 100%">
                        <el-option key="0" label="请选择" :value="0"></el-option>
                        <el-option key="1" label="成本价" :value="1"></el-option>
                        <el-option key="2" label="批发价" :value="2"></el-option>
                        <el-option key="3" label="销售价" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="点数" prop="PricePoint" >
                    <el-input-number v-model="formData.PricePoint" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="级别数序">
                    <el-input-number v-model="formData.LevelNum" disabled></el-input-number>
                </el-form-item>
                <el-form-item label="计算方式">
                    <el-radio-group v-model="formData.CalcType">
                        <el-radio :label="0">保留小数点</el-radio>
                        <el-radio :label="1">四舍五入</el-radio>
                        <el-radio :label="2">向上取整</el-radio>
                        <el-radio :label="3">向下取整</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="cancel()">关闭</el-button>
                <el-button class="btn-primary" @click="submitLevelForm">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['levelId', 'count'],
    name: '',
    data() {
        return {
            formData: {
                LevelId: '',
                LevelName: '',
                LevelNum: 1,
                PriceType: 0,
                PricePoint: 0,
                CalcType:0
            },
            rules: {
                LevelName: [
                    {
                        required: true,
                        message: '级别名称必填',
                        trigger: 'blur'
                    }
                ],
                PricePoint: [
                    {
                        required: true,
                        message: '价格点数必填（必须为数字类型）',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    mounted() {
        if (this.levelId) {
            this.formData.LevelId = this.levelId;
            this.getLevelInfo();
        }
        if (+this.count) {
            this.formData.LevelNum = +this.count + 1;
        }
    },
    methods: {
        getLevelInfo() {
            let url = '/api/EntpInfoManagement/GetCusPriceLevelById';
            this.$util
                .axiosGet({
                    url: url,
                    data: {
                        LevelId: this.formData.LevelId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.formData.LevelName = res.data.LevelName;
                        this.formData.LevelNum = res.data.LevelNum;
                        this.formData.PriceType = res.data.PriceType;
                        this.formData.PricePoint = res.data.PricePoint;
                        this.formData.CalcType = res.data.CalcType;
                    }
                })
                .catch(() => {});
        },
        // 提交表单
        submitLevelForm() {
            let that = this;
            that.$refs.formData.validate(valid => {
                if (valid) {
                    let url = '/api/EntpInfoManagement/SubmitCusPriceLevel';
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.formData
                        })
                        .then(() => {
                            that.$util.successMsg('成功提交价格等级');
                            that.$emit('closeDialog', true);
                        })
                        .catch(() => {});
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.form-value {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    width: 100%;
}
.form-column {
    width: 33.33%;
}
.dialog-footer {
    text-align: right;
}
</style>
